<template>
  <div id="slideRheostat">
    <div class="container">
      <div class="header">
        <div class="titelbox">
          <div class="titelbox-ico" @click="tikass" bucaiji="true">
            <van-icon name="arrow-left" />
          </div>
          <div class="titelbox-tm">
            <span class="nub">{{ swipeIndex + 1 }}</span
            >/{{ answerBox.length }}题
          </div>
          <div
            class="titelbox-tk"
            @click="tika"
            name="解析页-题卡"
            data-sensors-click
          >
            <img
              src="../assets/tk.png"
              alt=""
              name="解析页-题卡"
              data-sensors-click
            />
            题卡
          </div>
        </div>
      </div>
      <div class="main">
        <van-swipe
          @touchmove="touchmove()"
          class="my-swipe"
          :touchable="touchable"
          :show-indicator="false"
          indicator-color="white"
          :initial-swipe="swipeIndex"
          @change="onSwipe"
          :loop="false"
        >
          <van-swipe-item
            :initial-swipe="swipeItemIndex"
            v-for="(item, index) in answerBox"
            :key="index"
          >
            <div class="kmj">
              <div>
                <div class="answer">
                  <div class="answer-top">
                    <div class="questiontypes">
                      {{ item.Style }}
                      <span
                        v-for="(items, index) in quantitydata"
                        :key="index"
                        v-if="items.Style == item.Style"
                        >{{ item.indexs }}/{{ items.quantity }}</span
                      >
                    </div>
                    <div class="answer-title">
                      <!-- <span class="tag">{{ index + 1 }}</span
                    >/{{ answerBox.length
                    }}<span class="tag">[{{ item.Style }}]</span
                    > -->
                      <span
                        ref="content"
                        @click="imageEnlargement"
                        v-html="item.Title"
                      >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="answer-box">
                  <!-- 1.ATEST-单选
				    2.XTEST-多选
				    3.BTEST：如果SubType为空或为单项，则单选；如果SubType为多项则是多选; 如果SubType为不定项，则可能单选可能多选
				    4.A3TEST:如果SubType为空或为单项，则单选；如果SubType为多项则是多选; 如果SubType为不定项，则可能单选可能多选 -->

                  <ul>
                    <!-- v-if="items.StyleType=='ATEST'  || items.SubType=='单项' || items.StyleType!='XTEST'|| item.SubType!='不定项'" -->
                    <div
                      class="van-radio-group"
                      v-if="
                        item.Type == 'ATEST' ||
                        (item.Type == 'BTEST' && item.SubType == '') ||
                        (item.Type == 'BTEST' && item.SubType == '不定项') ||
                        (item.Type == 'BTEST' && item.SubType == '单项') ||
                        (item.Type == 'A3TEST' && item.SubType == '单项') ||
                        (item.Type == 'A3TEST' && item.SubType == '')
                      "
                    >
                      <div
                        v-for="(Selected, SelectedIndex) in item.SelectedItems"
                        class="checkedBox van-radio"
                        :key="SelectedIndex"
                        checked-color="#ffb300"
                      >
                        <div class="yqbox">
                          <div
                            class="checkedBox-left"
                            :class="
                              topicAnswer[swipeIndex].ItemName ==
                              Selected.ItemName
                                ? item.Answer == Selected.ItemName
                                  ? 'answerColor'
                                  : 'wrongColor'
                                : ''
                            "
                          >
                            {{ Selected.ItemName }}
                          </div>
                        </div>

                        <div
                          class="checkedBox-right"
                          :class="
                            item.Answer == Selected.ItemName ||
                            item.Answer == Selected.Content
                              ? 'answerColors'
                              : topicAnswer[swipeIndex].ItemName ==
                                  Selected.ItemName ||
                                topicAnswer[swipeIndex].ItemName ==
                                  Selected.Content
                              ? 'wrongColors'
                              : ''
                          "
                        >
                          <span ref="content" v-html="Selected.Content"></span>
                          <!-- {{ Selected.Content }} -->
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        item.Type == 'XTEST' ||
                        (item.Type == 'BTEST' && item.Type == '多项') ||
                        (item.Type == 'BTEST' && item.Type == '不定项') ||
                        (item.Type == 'A3TEST' && item.SubType == '多项') ||
                        (item.Type == 'A3TEST' && item.SubType == '不定项') ||
                        (item.Type == 'A3TEST' && item.SubType == '不定向')
                      "
                    >
                      <!-- -->
                      <div
                        v-for="(Selected, SelectedIndex) in item.SelectedItems"
                        class="checkedBox van-radio"
                        :key="SelectedIndex"
                        @click="
                          onCheckboxAnswer(
                            index,
                            Selected.ItemName,
                            SelectedIndex
                          )
                        "
                        checked-color="#ffb300"
                      >
                        <div class="yqbox">
                          <div
                            class="checkedBox-leftb"
                            :class="
                              topicAnswer[swipeIndex].ItemName.indexOf(
                                Selected.ItemName
                              ) != -1
                                ? item.AnswerArray.indexOf(Selected.ItemName) !=
                                  -1
                                  ? 'correctBg'
                                  : topicAnswer[swipeIndex].ItemName.indexOf(
                                      Selected.ItemName
                                    ) != -1
                                  ? 'wrongBg'
                                  : ''
                                : ''
                            "
                          >
                            {{ Selected.ItemName }}
                          </div>
                        </div>
                        <div
                          class="checkedBox-right"
                          :class="
                            item.AnswerArray.indexOf(Selected.ItemName) != -1
                              ? 'answerColors'
                              : topicAnswer[swipeIndex].ItemName.indexOf(
                                  Selected.ItemName
                                ) != -1
                              ? 'wrongColors'
                              : ''
                          "
                        >
                          <span ref="content" v-html="Selected.Content"> </span>
                        </div>
                      </div>
                    </div>
                    <!-- 简答题 -->
                    <div
                      class="textareas-box"
                      v-if="item.StyleType == 'JDTEST'"
                    >
                      <div class="textareas">
                        {{ topicAnswer[index].ItemName }}
                      </div>
                      <div style="color: rgb(153, 153, 153)">
                        本题不支持答题情况判断，可在交卷后核对答案并查看解析
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
              <div>
                <!-- 单 -->
                <div
                  v-if="
                    item.Type == 'ATEST' ||
                    (item.Type == 'BTEST' && item.SubType == '') ||
                    (item.Type == 'BTEST' && item.SubType == '单项') ||
                    (item.Type == 'A3TEST' && item.SubType == '单项') ||
                    (item.Type == 'A3TEST' && item.SubType == '') ||
                    item.Type == 'PDTEST'
                  "
                >
                  <div class="tikade">
                    <div class="Explain">
                      <div class="Explain-left">
                        <div class="Explain-answer">
                          <div class="ydsb"></div>
                          <ul>
                            <li class="dade">
                              答案:<span
                                class="answerColors font-weight-bold"
                                >{{ item.Answer }}</span
                              >
                            </li>

                            <!-- <li>试题反馈</li> -->
                          </ul>
                        </div>

                        <div class="myselect">
                          <span class="msd font-weight-bold"></span>您选择:{{
                            topicAnswer[swipeIndex].ItemName
                          }}
                        </div>
                      </div>

                      <div class="Explain-right">
                        <img
                          src="../assets/zq.png"
                          class="Explain-right-img"
                          v-show="
                            topicAnswer[swipeIndex].ItemName == item.Answer
                          "
                        />
                        <img
                          src="../assets/cw.png"
                          class="Explain-right-img"
                          v-show="
                            topicAnswer[swipeIndex].ItemName != item.Answer &&
                            topicAnswer[swipeIndex].ItemName != ''
                          "
                        />
                        <img
                          src="../assets/wzd.png"
                          class="Explain-right-img"
                          v-show="topicAnswer[swipeIndex].ItemName == ''"
                        />
                      </div>
                    </div>
                    <div class="analysis">
                      <div class="yds"></div>
                      <div class="analysis-left">
                        <li class="analysis-text">
                          解析:
                          <span ref="content" v-html="item.Explain"> </span>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 单 end -->
                <!-- 多选 -->
                <div
                  v-if="
                    item.Type == 'XTEST' ||
                    (item.Type == 'BTEST' && item.SubType == '多项') ||
                    (item.Type == 'BTEST' && item.SubType == '不定项') ||
                    (item.Type == 'A3TEST' && item.SubType == '多项') ||
                    (item.Type == 'A3TEST' && item.SubType == '不定项')
                  "
                >
                  <div class="tikade">
                    <div class="Explain">
                      <div class="Explain-left">
                        <div class="Explain-answer">
                          <ul>
                            <li>
                              <span class="msd font-weight-bold"></span
                              >答案：<span class="answerColor">{{
                                item.Answer
                              }}</span>
                            </li>
                          </ul>
                        </div>
                        <div class="myselect">
                          <span class="msd font-weight-bold"></span>您选择:{{
                            topicAnswer[swipeIndex].ItemName
                          }}
                        </div>
                      </div>
                      <div class="Explain-right">
                        <div class="Explain-right">
                          <img
                            src="../assets/zq.png"
                            class="Explain-right-img"
                            v-show="
                              topicAnswer[swipeIndex].ItemName == item.Answer
                            "
                          />
                          <img
                            src="../assets/cw.png"
                            class="Explain-right-img"
                            v-show="
                              topicAnswer[swipeIndex].ItemName != item.Answer &&
                              topicAnswer[swipeIndex].ItemName != ''
                            "
                          />
                          <img
                            src="../assets/wzd.png"
                            class="Explain-right-img"
                            v-show="topicAnswer[swipeIndex].ItemName == ''"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="analysis">
                      <div class="yds"></div>
                      <div class="analysis-left">
                        <li class="analysis-text">解析：</li>
                      </div>
                      <div class="analysis-details">
                        <span ref="content" v-html="item.Explain"> </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-show="item.StyleType == 'JDTEST'"
                  style="border-top: 5px solid #eeeeee; margin-top: 50px"
                  class="tikade"
                >
                  <div class="Explain">
                    <div class="Explain-left">
                      <div class="Explain-answer">
                        <ul>
                          <li style="font-size: 15px">
                            答案:<span
                              class="answerColor font-weight-bold"
                              style="margin-left: 10px; font-size: 15px"
                              >{{ item.Answer }}</span
                            >
                          </li>
                          <!-- <li>试题反馈</li> -->
                        </ul>
                      </div>
                    </div>
                    <div class="Explain-right">
                      {{ topicAnswer[swipeIndex].ItemName }}
                      <img
                        src="../assets/zq.png"
                        class="Explain-right-img"
                        v-show="topicAnswer[swipeIndex].ItemName == item.Answer"
                      />
                      <img
                        src="../assets/cw.png"
                        class="Explain-right-img"
                        v-show="
                          topicAnswer[swipeIndex].ItemName != item.Answer &&
                          topicAnswer[swipeIndex].ItemName != ''
                        "
                      />
                      <img
                        src="../assets/wzd.png"
                        class="Explain-right-img"
                        v-show="topicAnswer[swipeIndex].ItemName == ''"
                      />
                    </div>
                  </div>

                  <div class="analysis">
                    <div class="yds"></div>
                    <div class="analysis-left">
                      <li class="analysis-text">解析：</li>
                    </div>
                    <div class="analysis-details">无</div>
                  </div>
                </div>
                <div style="height: 60px; width: 100%"></div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="footer">
        <div class="diban">
          <van-button round type="info" @click="toptm" name="上一题"
            >上一题</van-button
          >
          <van-button round type="info" @click="btntm" name="下一题"
            >下一题</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var that;
import Vue from "vue";
import {
  Swipe,
  SwipeItem,
  RadioGroup, //单选
  Radio,
  Checkbox, //多选
  CheckboxGroup,
  Dialog, //确定取消弹出框
  CountDown, //倒计时
  Popup, //底部弹出框
  Field,
} from "vant";
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.Component.name]: Dialog.Component,
    [CountDown.name]: CountDown,
    [Popup.name]: Popup,
    [Field.name]: Field,
  },
  data() {
    return {
      swipeIndex: 0, //swipe
      swipeItemIndex: 0, //swipeItem
      fullHeight: document.documentElement.clientHeight, //屏幕高度
      touchable: true, //是否可以滑动
      subjectChoose: {}, //选择科目穿过来的值
      answerBox: [], //所有题目
      radio: [], //多选单选值
      group: [], //用来暂时存储多选题目答案，再转换成字符串保存到topicAnswer
      topicAnswerTrue: true, //用来判断储存答案数组是否创建，创建了第二次不在重复创建
      topicAnswer: [], //存储多选单选答案
      multiSelectShow: false, //判断是否显示答案
      AppID: "", //AppID
      simulationTrue: false, //查看答案题目显示颜色
      showMask: false, //题卡
      fullHeight: document.documentElement.clientHeight, //屏幕高度
      contrastAnswer: [], //正确答案
      haveAnswer: [], //已答题目
      accuracy: "",
      ConfigJson: "", //官方配置返回数据
      //考试用时
      achievementsDate: "", //考试时间
      popupShow: false, //显示笔记弹出框
      noteContent: "", //笔记内容
      guid: "", //用户信息
      messageDa: [], //简答题
      quantitydata: JSON.parse(localStorage.getItem("quantitydata")),
    };
  },
  created() {},
  mounted() {
    that = this;
    let subjectChoose = JSON.parse(localStorage.getItem("subjectChoose"));
    if (localStorage.getItem("index")) {
      that.swipeIndex = parseInt(localStorage.getItem("index"));
    }
    that.topicAnswer = JSON.parse(localStorage.getItem("topicAnswer"));

    that.answerBox = JSON.parse(
      localStorage.getItem("achievementsBox")
    ).answerBox; //所有答案
  },
  methods: {
    imageEnlargement(e) {
      if (e.target.nodeName == "IMG") {
        //判断点击富文本内容为img图片
        var str = e.target.src;
        ImagePreview([str]);
      } else {
      }
    },
    tikass() {
      Dialog.confirm({
        title: "确定退出答题解析页面吗？",
        message: "",
        confirmButtonColor: "#65b2ff",
      })
        .then(() => {
          this.$router.push({
            path: "/home",
            query: {
              configID: localStorage.getItem("configID"),
              agentCode: localStorage.getItem("agentCode"),
            },
          });
        })
        .catch(() => {});
    },
    //点击提卡
    tika() {
      that.$router.push({
        path: "/achievements",
      });
    },
    //上一题
    toptm() {
      if (this.swipeIndex == 0) {
        this.$toast("当前题目第一题");
        return;
      }
      this.swipeIndex--;
    },
    //下一题
    btntm() {
      if (this.swipeIndex + 1 == this.answerBox.length) {
        this.$toast("没有题目了");
        return;
      }
      this.swipeIndex++;
    },
    onAnswer_exam: function () {
      that.$router.push({
        path: "/achievements",
        query: {
          topicAnswer: this.topicAnswer,
          achievementsBox: that.$route.query.achievementsBox,
        },
      });
    },
    //多选查看答案
    onExamine: function () {
      that.multiSelectShow = true;
      that.simulationTrue = true;
    },
    onSwipe: function (e) {
      that.swipeIndex = e; //页面位置
      that.swipe = e;
      that.swipeItemIndex = e; //页面位置
      that.group = [];
    },

    //返回
    onArrowsLeft: function () {
      that.$router.push({
        path: "/questionBank",
        query: {},
      });
    },

    //题卡---返回试题页面
    onFreeQuestionBank: function () {
      that.showMask = false;
    },
    //多选
    onCheckboxAnswer: function (index, ItemName, SelectedIndex) {
      return;
    },
    //创建数据储存选中答案
    topicAnswerArray() {
      var topicAnswer = new Array();
      if (that.topicAnswerTrue) {
        for (let i = 0; i < that.answerBox.length; i++) {
          var data = {
            // index: "",
            ItemName: "",
          };
          that.topicAnswer.push(data);
        }
        that.topicAnswerTrue = false;
      }
    },
    onChange: function (e) {},

    //对错答案
    answerContrast() {
      let answerBox = that.answerBox; //后台返回的题目数据
      var correctAnswer = new Array(); //正确答案
      var contrastAnswer = new Array(); //把对比正确答案存储
      var haveAnswer = new Array(); //把已答题目储存
      for (let i in answerBox) {
        correctAnswer.push(answerBox[i].Answer);
        if (correctAnswer.indexOf(that.topicAnswer[i].ItemName) != -1) {
          contrastAnswer.push(that.topicAnswer[i].ItemName);
        } else {
        }
        //获取已答题数量
        if (that.topicAnswer[i].ItemName != "") {
          haveAnswer.push(that.topicAnswer[i].ItemName);
        }
      }
      that.contrastAnswer = contrastAnswer; //正确答案
      that.haveAnswer = haveAnswer; // 已答题目
      that.accuracy = (contrastAnswer.length / haveAnswer.length) * 100;
    },

    //判断手滑动方向
    slideRheostat() {
      var mybody = document.getElementById("slideRheostat");
      var startX, startY, moveEndX, moveEndY, X, Y;
      mybody.addEventListener(
        "touchstart",
        function (e) {
          // e.preventDefault();
          startX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
        },
        false
      );
      mybody.addEventListener("touchmove", function (e) {
        // e.preventDefault();
        moveEndX = e.changedTouches[0].pageX;
        moveEndY = e.changedTouches[0].pageY;
        X = moveEndX - startX;
        Y = moveEndY - startY;
        if (Math.abs(X) > Math.abs(Y) && X > 0) {
          // right
          // that.$toast("第一页1",index);
        } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
          // left
          // that.$toast("第一页2");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.kmj {
  height: calc(100vh - 200px);
  overflow: scroll;
  padding-bottom: 100px;
}
.questiontypes {
  font-size: 30px;
  padding: 0 34px;
  padding-top: 30px;
}

.myselect {
  padding-left: 22px;
  font-size: 30px;
  padding-top: 25px;
  padding-bottom: 32px;
}

.msd {
  width: 16px;
  height: 16px;
  background: #feaa44;
  border-radius: 100%;
  display: inline-block;
  margin-right: 18px;
}

.answerimg {
  position: absolute;
  right: 70px;
}

.answerimg img {
  width: 24px;
  height: 24px;
}

.answerColors {
  color: #feaa44;
}

.dade {
  padding-left: 40px;
  font-size: 30px;
}

.analysis {
  position: relative;
  padding-bottom: 40px;
}

.yds {
  width: 16px;
  height: 16px;
  opacity: 1;
  background: #feaa44;
  border-radius: 50%;
  position: absolute;
  top: 0.4rem;
  left: -10px;
}

.ydsb {
  width: 16px;
  height: 16px;
  opacity: 1;
  background: #feaa44;
  border-radius: 50%;
  position: absolute;
  top: 0.7rem;
  left: 5px;
}

.tikade {
  // background: #f3f3f3;
  margin: 34px;
  border-radius: 25px;
  //   padding-top: 20px;
  box-shadow: 1px 1px 10px 1px rgba(239, 239, 239, 0.8);
}

.tikade ul li {
  padding-top: 43px;
}

#slideRheostat/deep/.van-swipe-item {
  height: calc(100vh - 50px);
  overflow: scroll;
}

.textareas-box {
  margin: 10px auto;
  width: 80%;
  height: 200px;
}

.textareas {
  height: 210px;
  padding: 20px;
  border: 1px solid #000000;
  white-space: normal;
  word-break: break-all;
  overflow: scroll;
  box-sizing: border-box;
}

//错颜色
.wrongColor {
  background: #ffd1d1;
  border: 1px solid #ffd1d1 !important;
  color: #f54949 !important;
}

.wrongColors {
  color: #f54949 !important;
}

.wrongBg {
  background: #ffd1d1 !important;
  color: #ffffff !important;
}

.tk-d {
  background: #6dd3b0 !important;
  color: #ffffff !important;
}

.tk-c {
  background: #ee7674 !important;
  color: #ffffff !important;
}

////对
.answerColor {
  color: #454444 !important;
  background: #dffbdb;
  border: 1px solid #dffbdb !important;
}

.answerColors {
  color: #22b76b !important;
}

.tabBar-bottom {
  color: #999;
}

.faceColors {
  color: #6dd3b0 !important;
}

.correctBg {
  background: #6dd3b0;
  color: #ffffff !important;
}

.line {
  display: inline-block;
  height: 30px;
  width: 5px;
  background: #5bb8fe;
}

.main {
  background: #ffffff;
}

.pitch {
  background: #5bb8fe;
  color: #ffffff !important;
}

.tag {
  color: #5bb8fe;
  margin: 0px 2px;
}

.navigation {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: rgba(91, 184, 255, 1);
  /* border-bottom: 1px solid #EEEEEE; */
  position: relative;
}

.arrowsLeft {
  display: flex;
  align-items: center;
  position: absolute;
  font-size: 30px;
  left: 20px;
  top: 50px;
  margin-top: -18px;
}

.navigationTitle {
  font-size: 30px;
}

// Explain
.Explain {
  //   background: #ffffff;
  //   padding: 30px;
  margin-top: 20px;
  display: flex;
  color: #888888;
  justify-content: space-between;
  box-sizing: border-box;
}

.Explain-answer {
  display: flex;
  align-items: center;
  margin-left: 20px;
  position: relative;
  font-size: 30px;
}

.Explain-answer ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.analysis-details {
  color: #888888;
}

.Explain-answer ul li {
}

.Explain-answer ul li:nth-child(2) {
  margin-left: 30px;
  font-size: 30px;
}

.analysis-left {
  display: flex;
  flex-direction: row;
}

.Explain-right-img {
  width: 116px !important;
  height: 76px !important;
  padding-right: 34px;
  padding-top: 24px;
}

.Explain-answer ul li:nth-child(3) {
  width: 120px;
  height: 50px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 20px;
  border: 1px solid #cccccc;
}

li {
  list-style: none;
}

.analysis {
  border-top: 1px solid #e7e7e7;
  margin: 0 30px;
  // padding: 0px 30px;
  box-sizing: border-box;
  color: #888888;
  font-size: 30px;
  text-align: left;
  padding-top: 20px;
  margin-top: 10px;
  //   background: #ffffff;
}

.xiand {
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.analysis-text {
  margin-left: 20px;
}

/*  */

.tabBar {
  width: 100%;
  height: 100px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  border-top: 1px solid #eeeeee;
  background: #ffffff;
}

.tabBar ul {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}

.tabBar ul li {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.tabBar li {
  display: flex;
  flex-direction: column;
}

/*  */
.answer-title {
  // border-bottom: 1px solid #cccccc;
  padding: 20px 30px;
  font-size: 30px;
  color: #454444;
  word-break: break-all;
  box-sizing: border-box;
}

// .answer-box/deep/.van-radio__label { //穿透
//   height: 90px;
//   font-size: 30px;
// }
.van-radio {
  margin-top: 10px;
  text-align: left;
  color: #888888;
}

.checkedBox {
  font-size: 0.386667rem;
  // padding: 0.44rem 0.133333rem;
  box-sizing: border-box;
  color: #454444;
  margin: 0.4rem 0.453333rem;
  // box-shadow: 1px 1px 10px 1px rgba(239, 239, 239, 0.8);
  padding-right: 1.333333rem;
  border-radius: 5px;
}

.yqbox {
  width: 80px;
}

.checkedBox-left {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  border: 1px solid #ccc;
  align-items: center;
  //   border: 2px solid #5bb8fe;
  //   color: #5bb8fe;
}

.checkedBox-right {
  margin-left: 30px;
}

.selectAnswer {
  font-size: 30px;
  margin-top: 5px;
  text-align: left;
  margin-left: 50px;
}

.accuracy {
  font-size: 30px;
  margin-top: 5px;
  margin-left: 50px;
}

.examine {
  width: 180px;
  height: 60px;
  border-radius: 10px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin: 0px auto;
  margin-top: 10px;
  background: #5bb8fe;
}

// 题卡
.mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.mask-main {
  position: fixed;
  z-index: 1000;
  width: 100%;
  /*  max-width: 300px;
	  min-height: 300px; */
  bottom: 0;
  left: 0%;
  // border-radius: 20px 20px 0px 0px;
  /* margin-left: -25%; */
  background-color: #ffffff;

  transition: height 2s;
  -moz-transition: height 2s;
  /* Firefox 4 */
  -webkit-transition: height 2s;
  /* Safari 和 Chrome */
  -o-transition: height 2s;
  /* Opera */
  box-sizing: border-box;
}

.card ul {
  display: flex;
  flex-direction: row;
}

.card ul li {
  display: flex;
  width: 0.8rem;
  height: 0.8rem;
  margin-left: 0.2rem;
  align-items: center;
  justify-content: center;
  background: #cccccc;
}

.exercises-top {
  width: 100%;
  padding: 10px 0px;
  background: #5bb8fe;
  box-sizing: border-box;
}

.navigations {
  width: 100%;
  height: 100px;
  display: flex;
  /* justify-content: space-between; */
  align-items: flex-end;
  padding: 10px 30px;
  font-size: 30px;
  color: #ffffff;
  box-sizing: border-box;
}

.arrowsLefts {
  flex: 1;
  text-align: left;
  font-size: 30px;
}

.title-tk {
  display: flex;
  flex: 1;
  justify-content: center;
}

.buy-s {
  display: flex;
  flex: 1;
}

.buy {
  padding: 5px 15px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  font-size: 25px;
  margin-left: 50px;
}

.score_content {
  position: relative;
  width: 63%;
  font-size: 30px;
  margin-left: 20px;
  border-radius: 4px;
  background: #3ba3f3;
  color: #fff;
  padding: 10px;
}

.score_content::after {
  border-right: 7px solid #3ba3f3;
}

.score_content::after {
  border-right: 7px solid #3ba3f3;
}

.score_content:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  left: -7px;
  top: 50%;
  margin-top: -10px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 7px solid #3ca1f7;
}

.score_content span {
  color: #fbe074;
  font-size: 30px;
  padding: 2px;
}

.sheetChart {
  display: flex;
  flex-direction: row;
  margin: 30px 30px;
  // margin: 20px 0px;
  box-sizing: border-box;
}

.reportSheet-box {
  display: flex;
  justify-content: space-around;
  font-size: 30px;
}

.bottomTab {
  width: 100%;
  display: flex;
  position: fixed;
  left: 0px;
  bottom: 0px;
  font-size: 30px;
}

.Tableft {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 15px 0px;
  color: #757575;
}

.Tabc {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  background: #5bb8ff;
  padding: 15px 0px;
  color: #ffffff;
}

.Tabright {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 15px 0px;
  color: #757575;
}

.NewcardContent-ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.NewcardContent-li {
  display: flex;
  width: 70px;
  height: 70px;
  border-radius: 80px;
  margin: 0px 25px;
  font-size: 30px;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
  color: #999999;
  background: #e8e8e8;
}

.van-popup-top {
  width: 100%;
  height: 100px;
  padding: 0px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
}

.van-popup-top-btn {
  display: block;
  padding: 10px 30px;
  color: #ffffff;
  font-size: 30px;
  border-radius: 30px;
  background: #5bb8ff;
}

.van-popup-top-cneten {
  font-size: 35px;
}

.icon-alicuo {
  font-size: 35px;
}

.textarea {
  border: none;
  width: 100%;
  height: 50%;
  padding: 30px;
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
}

.container {
  height: calc(100vh - 50px);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // overflow: scroll;
  /* margin: 100px 0; */
}

.header {
  z-index: 2;
  width: 100%;
  height: 100px;
  background-color: #e77c8e;
  position: fixed;
}

.main {
  width: 100%;
  flex: 1;
  // background-color: #2bae85;
  margin: 100px 0;
}

.footer {
  z-index: 2;
  width: 100%;
  height: 100px;
  // background-color: #7a7374;
  position: fixed;
  bottom: 0;
  box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8);
  background: #fff;
  z-index: 66666666666;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.titelbox {
  height: 100px;
  margin-bottom: 28px;
  line-height: 100px;
  background: #ffffff;
  box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8);
  padding: 0 33px;
  color: #1a1a1a;
}

.van-icon {
  top: 5px;
  color: #b4b4b4;
}

.nub {
  color: #ffbe6a;
}

.titelbox-ico {
  float: left;
  padding-right: 240px;
  font-size: 50px;
}

.titelbox-tm {
  float: left;
  font-size: 30px;
  padding-left: 10px;
  font-size: 30px;
  color: #000001;
  font-weight: 400;
}

.titelbox-tk {
  float: right;
  font-size: 30px;
}

.titelbox-tk img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 34px;
  right: 100px;
}

.diban {
  text-align: center;
  margin: 0 90px;
  display: flex;
  justify-content: space-between;
}

.van-button--normal {
  width: 200px;
  height: 70px;
  margin-top: 15px;
  background: #4c9cff;
  border: none;
  border-radius: 25px;
}

.font-weight-bold {
  font-weight: bold;
}
.checkedBox-leftb {
  width: 80px;
  height: 80px;
  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
  // padding-left: 30px;
  border: 1px solid #cccccc;
  color: #454444;
}
</style>
